import { resourceExplorerDimensionSelector } from "./resourceExplorerDimensionSelector";
import { RootState } from "../../../../store";

export const resourceExplorerCategoriesIdsSelector = (state: RootState) => {
  return resourceExplorerDimensionSelector(state)?.categoryIds;
};
